import { Dispatch, SetStateAction, useEffect } from 'react'
import { IContactProps } from '../CustomerInformation'
import { fetchData } from '../../../../../../global/utils/fetch'
import { getIsVehicleBlacklisted } from '../api'
import styles from './styles.module.css'
import AdditionalInformationSelect from './vehicle-info-selects/AdditionalInformationSelect'
import MakeInformationSelect from './vehicle-info-selects/MakeInformationSelect'
import ModelInformationSelect from './vehicle-info-selects/ModelInformationSelect'
import YearInformationSelect from './vehicle-info-selects/YearInformationSelect'
import { ICustomerInformationData } from '../CustomerInformation'
import { MODES } from '../../../../../../global/constants/scheduler'

export interface IVehicleInformationSelectProps {
  formData: ICustomerInformationData
  setFormData: Dispatch<SetStateAction<ICustomerInformationData>>
  label: string
}

export interface IVehicleInformationFormProps extends IContactProps {
  isBlacklisted: boolean
  setIsBlacklisted: Dispatch<SetStateAction<boolean>>
  setDisabled: Dispatch<SetStateAction<boolean>>
  mode: MODES
}

export default function VehicleInformationForm(
  props: IVehicleInformationFormProps,
) {
  const {
    formData,
    setFormData,
    setDisabled,
    mode,
    isBlacklisted,
    setIsBlacklisted,
  } = props

  useEffect(() => {
    async function checkIsBlacklistedVehicle() {
      if (formData.brandName && formData.model && formData.year) {
        const blacklistedResult = await fetchData<boolean>(
          getIsVehicleBlacklisted(
            formData.brandName,
            formData.model,
            formData.year,
          ),
        )
        setIsBlacklisted(blacklistedResult)
        //we only want to disable the next button if the vehicle is blacklisted and we're not in public-facing mode
        setDisabled(blacklistedResult && MODES.CUSTOMER !== mode)
      } else {
        setIsBlacklisted(false)
        setDisabled(false)
      }
    }
    checkIsBlacklistedVehicle()
  }, [
    formData.brandName,
    formData.model,
    formData.year,
    formData.additionalInformation,
  ])

  return (
    <div className={styles.contactFormContainer}>
      <div className={`${styles.contactTitle} font--bold`}>
        Vehicle Information
      </div>
      <MakeInformationSelect
        label='Make'
        formData={formData}
        setFormData={setFormData}
      />
      {formData.brandName && (
        <YearInformationSelect
          label='Year'
          formData={formData}
          setFormData={setFormData}
        />
      )}
      {formData.year && (
        <ModelInformationSelect
          label='Model'
          formData={formData}
          setFormData={setFormData}
        />
      )}
      {formData.model && (
        <AdditionalInformationSelect
          label='Additional Information'
          formData={formData}
          setFormData={setFormData}
        />
      )}
      {isBlacklisted && (
        <div style={{ color: 'red' }}>
          This vehicle cannot be serviced by Mobile Installation
        </div>
      )}
    </div>
  )
}
